import { gql } from 'graphql-request';

import { LANGUAGE_QUERY_FRAGMENT } from './language-gql';

import type { RequestDocument } from 'graphql-request';

// Selection for an `ai_voice` catalog record. Mirrors
// TRANSLATION_HANDLER_QUERY_FRAGMENT; `model` links to `ai_model` (same shape
// as a language's defaultModel) and `supportedLanguages` reuses the language
// fragment.
export const AI_VOICE_QUERY_FRAGMENT = gql`
  {
    id
    name
    internalName
    description
    image {
      url
    }
    provider
    gender
    model {
      id
      internalName
      displayName
      modelId
    }
    providerVoiceId
    providerUrl
    supportedLanguages ${LANGUAGE_QUERY_FRAGMENT}
    voiceSamples
    isDefault
    isActive
  }
`;

export const ALL_AI_VOICES_QUERY: RequestDocument = gql`
  query {
    allAiVoices(first: 100, filter: { isActive: { eq: true } }) ${AI_VOICE_QUERY_FRAGMENT}
  }
`;
